import React from "react";
import { useStatusToast } from "./StatusToastContext";

const StatusToaster = () => {
  const { status, message, showToast } = useStatusToast();

  if (!showToast || status === "idle") return null;

  const bgColor =
    status === "uploading" ? "bg-blue-600" :
    status === "updated" ? "bg-green-600" :
    status === "error" ? "bg-red-600" : "bg-gray-600";

  return (
    <div
      className={`fixed top-4 left-1/2 transform -translate-x-1/2 px-6 py-3 rounded-md shadow-lg text-white z-[9999] ${bgColor}`}
    >
      <strong className="capitalize">{status}</strong>: {message}
    </div>
  );
};

export default StatusToaster;